import { cardsItems } from '@/mocks/home';

export default function CardsSection() {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
  };

  return (
    <section id="cards" className="w-full py-12 md:py-16 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 tracking-wide">
            精选专题
          </h2>
          <p className="mt-3 text-sm text-foreground-600 max-w-lg mx-auto">
            深度策划的影视专题合集，发现更多优质内容
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {cardsItems.slice(0, 6).map((item, idx) => (
            <a
              key={idx}
              href="#cards"
              onClick={handleClick}
              className="group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden cursor-pointer no-underline transition-all duration-200 hover:border-primary-300/50"
            >
              <div className="relative w-full aspect-[3/2] overflow-hidden">
                <img
                  src={item.image}
                  alt={`51影院 - ${item.title}`}
                  title={`51影院${item.title}`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 bg-primary-500 text-white text-xs rounded-md font-medium">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-2">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-2">
                  {item.description}
                </p>
              </div>
            </a>
          ))}
        </div>

        {cardsItems.length > 6 && (
          <div className="mt-6">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
              {cardsItems.slice(6).map((item, idx) => (
                <a
                  key={idx + 6}
                  href="#cards"
                  onClick={handleClick}
                  className="group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden cursor-pointer no-underline transition-all duration-200 hover:border-primary-300/50"
                >
                  <div className="relative w-full aspect-[3/2] overflow-hidden">
                    <img
                      src={item.image}
                      alt={`51影院 - ${item.title}`}
                      title={`51影院${item.title}`}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                      loading="lazy"
                    />
                    <div className="absolute top-3 left-3">
                      <span className="px-2.5 py-1 bg-primary-500 text-white text-xs rounded-md font-medium">
                        {item.tag}
                      </span>
                    </div>
                  </div>
                  <div className="p-4 md:p-5">
                    <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-2">
                      {item.title}
                    </h3>
                    <p className="text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-2">
                      {item.description}
                    </p>
                  </div>
                </a>
              ))}
            </div>
          </div>
        )}
      </div>
    </section>
  );
}